import type { CSSProperties } from 'react';

type TagPalette = { color: string; background: string; borderColor: string };

const COVARIATE_PALETTES: Record<string, TagPalette> = {
  WT: { color: '#245B9B', background: '#EEF5FC', borderColor: '#C9DCF1' },
  WEIGHT: { color: '#245B9B', background: '#EEF5FC', borderColor: '#C9DCF1' },
  AGE: { color: '#22717B', background: '#EDF8F8', borderColor: '#C5E5E6' },
  PMA: { color: '#69539A', background: '#F4F0FA', borderColor: '#DCCFED' },
  PNA: { color: '#92577A', background: '#FAF0F5', borderColor: '#EBCFDE' },
  SCR: { color: '#9A672A', background: '#FCF5E9', borderColor: '#ECD8B5' },
  CRCL: { color: '#397159', background: '#EFF7F2', borderColor: '#CBE2D4' },
  HEIGHT: { color: '#3F628B', background: '#F0F4F8', borderColor: '#CBD8E5' },
  BSA: { color: '#617632', background: '#F5F8EC', borderColor: '#DBE4C2' },
  SEX: { color: '#8A6230', background: '#FAF5EC', borderColor: '#E7D7BC' },
  GENDER: { color: '#8A6230', background: '#FAF5EC', borderColor: '#E7D7BC' },
};

const FALLBACK_PALETTES: TagPalette[] = [
  { color: '#365F86', background: '#F0F5FA', borderColor: '#CDDAE7' },
  { color: '#69539A', background: '#F4F0FA', borderColor: '#DCCFED' },
  { color: '#397159', background: '#EFF7F2', borderColor: '#CBE2D4' },
  { color: '#92577A', background: '#FAF0F5', borderColor: '#EBCFDE' },
  { color: '#9A672A', background: '#FCF5E9', borderColor: '#ECD8B5' },
];

export const POPULATION_TAG_COLOR: Record<string, string> = {
  早产儿: 'purple',
  足月新生儿: 'magenta',
  新生儿: 'volcano',
  婴儿: 'orange',
  儿童: 'gold',
  青少年: 'lime',
  成人: 'blue',
  老年: 'geekblue',
  老年人: 'geekblue',
  全年龄段: 'cyan',
};

export const getPopulationTagColor = (population?: string): string => (
  POPULATION_TAG_COLOR[String(population || '').trim()] || 'default'
);

const normalizedKey = (value?: string) => String(value || '').trim().toUpperCase();

const stablePalette = (value?: string): TagPalette => {
  const key = normalizedKey(value);
  if (COVARIATE_PALETTES[key]) return COVARIATE_PALETTES[key];
  const hash = Array.from(key).reduce((total, char) => total + char.charCodeAt(0), 0);
  return FALLBACK_PALETTES[hash % FALLBACK_PALETTES.length];
};

export const getCovariateTagStyle = (key?: string): CSSProperties => ({
  ...stablePalette(key),
  marginInlineEnd: 0,
});

export const getDrugTagStyle = (drug?: string): CSSProperties => {
  const palette = stablePalette(`DRUG_${drug || ''}`);
  return { ...palette, marginInlineEnd: 0 };
};
